// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var ThirdPartyIntegrationSettingsController = function ($scope, $location, $routeParams, $http,  ThirdPartyIntegrationSettings) {

    const THIRD_PARTY_INTEGRATION = Object.freeze({
        'Atriga': 'Atriga',
        'Avalara': 'Avalara',
        'Epay': 'Epay',
        'AzureActiveDirectory': 'AzureActiveDirectory',
        'OpenIdConnect': 'OpenIdConnect',
        'Ecosio': 'Ecosio'
    });
    
    $scope.taxPoliciesUrl = window.location.href.split("/")
        .slice(0, 5)
        .join('/') + '/taxpolicies';
    
    $scope.thirdPartyIntegrationType = THIRD_PARTY_INTEGRATION;
    $scope.settingsLoaded = false;

    if ($routeParams.thirdPartyIntegration) {
        ThirdPartyIntegrationSettings.get({thirdPartyIntegration: $routeParams.thirdPartyIntegration}).$promise.then(function (response) {
            $scope.settings = response;
            $scope.settingsLoaded = true;
            
            if ($scope.settings.ThirdPartyIntegration === 'Avalara' && !$scope.settings.CompanyCode) {
                $scope.settings.CompanyCode = "DEFAULT";
            }
        });

        $scope.thirdPartyIntegration = $routeParams.thirdPartyIntegration;
    } else {
        $scope.integrations = ThirdPartyIntegrationSettings.query();
    }

    var verifyAndSave = function (provider) {
        $http({
            method: "POST", url: "OIDCSettings/Challenge",
            params: {provider: provider, returnUrl: "/#/settings/thirdparty-integration"},
            data: $scope.settings,
            headers: { "Content-Type": "application/json" },
            cache: false
        }).then(function (redirectUrl) {
            window.location = redirectUrl.data;
        });
    };

    $scope.save = function (provider) {
        if (provider === THIRD_PARTY_INTEGRATION.AzureActiveDirectory || provider === THIRD_PARTY_INTEGRATION.OpenIdConnect){
            verifyAndSave(provider);
        }
        else{
            $scope.settings.$update({thirdPartyIntegration: $routeParams.thirdPartyIntegration}, function () {
                    $location.path("/settings/thirdparty-integration");
            });
        }
    };

    $scope.camelCaseToWords = function (value) {
        return value.replace(/([A-Z])/g, " $1").trim();
    }

};
ThirdPartyIntegrationSettingsController.$inject = ['$scope', '$location', '$routeParams', '$http', 'ThirdPartyIntegrationSettings'];
